import { Check } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const classNames = {
  success:
    "rounded-full bg-emerald-100 text-emerald-700 border-emerald-100 dark:bg-emerald-900/20 dark:text-emerald-400 dark:border-emerald-900/20 h-[22px]",
  warning:
    "rounded-full bg-orange-100 text-orange-700 border-orange-100 dark:bg-orange-900/20 dark:text-orange-400 dark:border-orange-900/20 h-[22px]",
  destructive:
    "rounded-full bg-destructive/20 text-destructive/70 border-destructive/20 dark:bg-destructive/20 dark:text-destructive dark:border-destructive/20 h-[22px]",
  default: "rounded-full h-[22px]",
};
const sizeClassNames = {
  xs: "text-[8px] px-1 py-0",
  sm: "text-[10px] px-1.5 py-0",
  md: "text-xs px-2 py-0.5",
  lg: "text-base px-3 py-1",
};

export const Count = ({
  count,
  variant = "default",
  size = "md",
  noSuccess = false,
  className,
}: {
  count: number | string;
  variant?: "success" | "warning" | "destructive" | "default";
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
  noSuccess?: boolean;
}) => {
  const _className = classNames[variant];
  const sizeClassName = sizeClassNames[size];

  if (count === 0 && !noSuccess)
    return (
      <Badge variant="outline" className={classNames.success}>
        <Check
          size={
            size === "xs" ? 10 : size === "sm" ? 12 : size === "md" ? 14 : 16
          }
          className="text-emerald-600 dark:text-emerald-400"
        />
      </Badge>
    );

  return (
    <Badge
      variant="outline"
      className={cn(_className, sizeClassName, className)}
    >
      {count}
    </Badge>
  );
};
